<template>
    <div class="enviados">
        <vs-table v-if="tablaEnviados" class="table-responsive" v-dragscroll="{ target: '.vs-table', active: true }">
            <template #tbody>
                <template v-for="(tr, i) in enviados">
                    <vs-tr
                        :key="i + 1"
                        
                        :data="tr"
                        v-if="tr.sended === 1"
                        :style="tr.sended === 1 ? 'border-bottom: 1px solid #cccc; cursor:pointer' : 'border:none' "
                    >
                    <template  v-for="(jobs, j) in tr.jobs">
                        <vs-td :key="j" v-if="tr.sended === 1" @click="getShowReenviar(tr, i)">
                            <span style="text-transform: capitalize;">{{ jobs.from_name }}</span>
                        </vs-td>
                    </template>
                        <vs-td  v-if="tr.sended === 1" @click="getShowReenviar(tr, i)">
                            <strong> {{ tr.subject }} </strong>
                        </vs-td>
                    </vs-tr>
                </template>
            </template>
            <template #notFound>
                No hay correos enviados.
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
        </vs-table>
        <enviar v-if="reenviar" :info="info" :infoIndex="infoIndex" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getRefreshTable()"></enviar>
    </div>
</template>

<script>
import enviar from './correo-enviado.vue'
export default {
    props: [
        'enviados',
        'institucion',
        'cicloEscolar',
        'enviadosInfo',
        'pages'
    ],
    data(){
        return{
            color: {
                "asunto": "green",
                "Cheque nominativo": "yellow",
            },
            tablaEnviados: true,
            reenviar: false,
            info: [],
            search: '',
            page: 1
        }
    },
    components: {
        enviar
    },
    created(){
        // this.getDate()
    },
    methods:{
        getRefreshTable(){
            this.$emit('refreshTable', true);
        },
        getColor(type){
            if (type === 'asunto'){
                return `col-${this.color['asunto']}`
            }else if (type === 'Cheque nominativo'){
                return `col-${this.colorFactura[type]}`
            }else if (type === 'Transferencia electrónica de fondos'){
                return `col-${this.colorFactura[type]}`
            }
        },
        getShowReenviar(tr, i){
            this.tablaEnviados = false
            this.reenviar = true
            this.info = tr
            this.infoIndex = i
        },
        getDate(info){
            if(info){
                const f = new Date(info.updated_at);
                const result = f.toLocaleString();
                return result
            }
        }
    },
    watch:{
        enviadosInfo(){
            this.tablaEnviados = true
            this.reenviar = false
            this.$emit('reAbrirEnviados', true);
        },
        page(){
            this.$emit('refreshTablePage', this.page);
        }
    }
}
</script>

<style>
    .enviados .table-responsive{
        margin-top: 3% !important;
    }
</style>


<style scoped>
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-chip{
        height: 24px !important;
        line-height: 24px !important;
    }
</style>